/**
 * HA-481: the sizes of the fixed bars, so whatever has to clear them uses the same numbers. The header was 70px while
 * the pages reserved 56px, which put the top of the content under it.
 */
export const HEADER_HEIGHT = 70;
export const MOBILE_BOTTOM_NAV_HEIGHT = 64;
